import { X } from 'lucide-react';
import { ReactNode } from 'react';
import { Alert } from '../../../Alert/Alert';
import {
  AlertColor,
  AlertVariant,
} from '../../../Alert/alertClasses/alertClasses';
import { Button } from '../../../Button/Button';
import { IconButton } from '../../../IconButton/IconButton';
import { ToastAction } from '../../../../../shared/toast/useToast/Toast';
import {
  toastAlertClasses,
  ToastAlertWidth,
} from './toastAlertClasses/toastAlertClasses';

/**
 * What a toast looks like: an Alert with its action and a close button in the
 * action slot. Not named `Toast`, which is the type a screen calls to ask for
 * one.
 *
 * Action before close, in reading order.
 *
 * Presentation only; timing and replacement are ToastProvider's.
 */
export const ToastAlert = ({
  color,
  variant,
  width,
  action,
  onClose,
  className,
  children,
}: {
  color: AlertColor;
  variant?: AlertVariant;
  width?: ToastAlertWidth;
  action?: ToastAction;
  onClose?: () => void;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <Alert
      color={color}
      variant={variant}
      className={toastAlertClasses({ width, className })}
      action={
        action === undefined && onClose === undefined ? undefined : (
          <>
            {action !== undefined && (
              <Button variant='ghost' size='sm' onClick={action.onClick}>
                {action.label}
              </Button>
            )}
            {onClose !== undefined && (
              <IconButton
                size='sm'
                className='[--icon-btn-main:currentColor]'
                aria-label='Close'
                onClick={onClose}
              >
                <X aria-hidden='true' />
              </IconButton>
            )}
          </>
        )
      }
    >
      {children}
    </Alert>
  );
};
